import { useAssetVizInternal } from '@asset-viz/AssetVizInternalProvider'
import React, { FC, useMemo } from 'react'
import styled from 'styled-components'
import { GeckoCoatingRegion, GeckoComponentPolygon } from 'types'

import { PolygonFeatureLabel3D } from './procedural/PolygonFeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from './procedural/SurfaceLineFeature3D'
import {
  SurfaceMeshFeature3D,
  SurfaceMeshSelectionType,
} from './procedural/SurfaceMeshFeature3D'

const StyledPolygonFeatureLabel3D = styled(PolygonFeatureLabel3D)<{
  color: string
}>`
  color: ${(props) => props.color};
  font-weight: 900;
  overflow: visible;
`

export const CoatingRegionFeature3D: FC<{ model: GeckoCoatingRegion }> = ({
  model,
}) => {
  const { showPlateFeatureDebugColors, corrosionRegionColorString } =
    useAssetVizInternal()

  const boundingPath = useMemo(() => {
    return GeckoComponentPolygon.CreateFromRect(model.geometry)
  }, [model.geometry])

  return (
    <group key={model.id}>
      <SurfaceLineFeature3D
        path={boundingPath}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <SurfaceMeshFeature3D
        path={boundingPath}
        featureModel={model}
        selectionType={SurfaceMeshSelectionType.AssetModelEditorSelectable}
        showDebugColors={showPlateFeatureDebugColors}
        userDataName={'coating'}
      />
      <StyledPolygonFeatureLabel3D
        color={corrosionRegionColorString}
        feature={model}
        polygonPath={boundingPath}
      />
    </group>
  )
}
